/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
import { useTableKeyboardNavigation as f } from "../navigation/hooks.mjs";
import { disableNavigatableContainer as b } from "@progress/kendo-react-common";
const p = (t) => {
  const {
    ariaSort: i,
    colSpan: n,
    rowSpan: o,
    columnId: l,
    navigatable: e,
    ariaColumnIndex: c,
    ariaLabel: d,
    ariaSelected: s,
    ariaDescription: g,
    ...m
  } = t, u = f(l, e), a = r.useRef(null);
  return r.useEffect(() => {
    a.current && e && b(a.current);
  }, [e]), /* @__PURE__ */ r.createElement(
    "td",
    {
      ref: a,
      "aria-sort": i,
      "aria-label": d,
      "aria-colindex": c,
      "aria-selected": s,
      colSpan: n,
      rowSpan: o,
      ...u,
      ...m
    },
    t.children
  );
};
p.displayName = "KendoReactHeaderTdElement";
export {
  p as HeaderTdElement
};
